window.__assetPrefix__ = '/landing-ms';